import { SnoozeUpdate, useDqmTabs } from '@fullstory/dqm-ui';
import { APIEventIssueSilence, Issues } from '@fullstory/proto/fs/services/dx-objects';
import React from 'react';
import { APIEvent } from '../../data-mgmt';
import { useAPIEventsSignalStudio } from '../../data-mgmt/hooks/useAPIEventsSignalStudio';

interface APIEventModalProps {
  apiEventId?: string;
  apiEvent: APIEvent;
  onCloseSignal: () => void;
  showHints?: boolean;
  onSave: (apiEventName: string, specSlugs: string[]) => void;
  onArchive: (apiEventName: string) => void;
  onUnarchive: (apiEventName: string) => void;
  activityMonitoring?: Parameters<typeof useDqmTabs>[0]['activityMonitoring'];
  issues?: Issues;
  snoozed?: APIEventIssueSilence;
  setSnoozed?: (update: SnoozeUpdate) => void;
}

export const APIEventModal: React.FC<APIEventModalProps> = props => {
  const { SignalStudio, signalStudioProps } = useAPIEventsSignalStudio({
    ...props,
  });

  if (!SignalStudio) {
    return null;
  }
  return <SignalStudio data-component="APIEventModalSignalStudioImpl" {...signalStudioProps} />;
};
